import { createReducer, on } from '@ngrx/store';
import { JobsActions } from './jobs.actions';
import { Job } from '../../class/job.class';
import { TaskModel } from '../../models/task.model';
import { StatusEnum } from '../../enums/status.enum';
import { TaskEnum } from '../../enums/task.enum';

export const initialState: ReadonlyArray<Job> = [];

function sortTasks(tasks: TaskModel[]): TaskModel[] {
  return [...tasks].sort((a: TaskModel, b: TaskModel) => a.type - b.type);
}

export const JobsReducer = createReducer(
  initialState,
  on(JobsActions.removeJob, (state, { jobId }) =>
    state.filter((job: Job) => job.id !== jobId)
  ),
  on(JobsActions.addJob, (state, { job }) => {
    if (state.some((j: Job) => j.id === job.id)) return state;
    return [...state, job];
  }),
  on(JobsActions.addJobs, (state, { jobs }) => {
    const sortedJobs = jobs.map(job => new Job({
      ...job.data,
      tasks: sortTasks(job.data.tasks)
    }));
    return [...state, ...sortedJobs];
  }),
  on(JobsActions.sortJobs, (state, { sortType }) => {
    const sortedJobs = [...state].sort((a: Job, b: Job) => {
      switch (sortType) {
        case 'created_at':
          return new Date(b.data.created_at).getTime() - new Date(a.data.created_at).getTime();

        case 'status':
          return a.status.localeCompare(b.status);

        case 'task':
          return a.data.tasks[a.data.tasks.length - 1].type - b.data.tasks[b.data.tasks.length - 1].type;

        default:
          return 0;
      }
    });

    return [...sortedJobs];

  }),
  on(JobsActions.updateJobFromWsMessage, (state, { wsUpdateTaskMessage }) => {
    return state.map((job: Job) => {
      if (job.id !== wsUpdateTaskMessage.jobId) { console.warn('job not found'); return job };
      let taskExists = false;
      const taskRecived: TaskModel = {
        id: wsUpdateTaskMessage.taskId,
        status: StatusEnum[wsUpdateTaskMessage.status as keyof typeof StatusEnum],
        type: TaskEnum[wsUpdateTaskMessage.type as keyof typeof TaskEnum],
        job: wsUpdateTaskMessage.jobId,
        message: wsUpdateTaskMessage.message,
        progress: wsUpdateTaskMessage.progress,
        updated_at: wsUpdateTaskMessage.updated_at ? new Date(wsUpdateTaskMessage.updated_at) : null,
        created_at: wsUpdateTaskMessage.created_at ? new Date(wsUpdateTaskMessage.created_at) : null,
        deleted_at: null
      }
      const updatedTasks: TaskModel[] = job.data.tasks.map((task: TaskModel) => {
        if (task.id === wsUpdateTaskMessage.taskId) {
          taskExists = true;
          return {
            ...task,
            ...taskRecived
          };
        }
        return task;
      });

      updatedTasks.sort((a: TaskModel, b: TaskModel) => { return a.type - b.type })

      if (!taskExists) {
        updatedTasks.push(taskRecived);
      }
      return new Job({
        ...job.data,
        tasks: sortTasks(updatedTasks)
      });
    });
  })
);